import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetAppResponseBody } from '../AppsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseAppQueryValues = {
  appId: string;
};

export const appQueryKeyFactory: IQueryKeyFactory<IUseAppQueryValues> = (
  values,
) => values && (['apps', values.appId] as const);

export const useAppQuery = (
  values?: IUseAppQueryValues,
  options?: UseQueryOptions<IApiGetAppResponseBody, ApiError>,
): UseQueryResult<IApiGetAppResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: appQueryKeyFactory(values),
    queryFn: values ? () => api.apps.get(values.appId) : undefined,
    enabled: !!values,
    ...options,
  });
};
